export const GET_PICTURE_OF_THE_DAY = 'apod/GET_PICTURE_OF_THE_DAY';
export const GET_PICTURE_OF_THE_DAY_SUCCESS = 'apod/GET_PICTURE_OF_THE_DAY_SUCCESS';
export const GET_PICTURE_OF_THE_DAY_FAILURE = 'apod/GET_PICTURE_OF_THE_DAY_FAILURE';

export const GET_PREVIOUS_OR_NEXT_DAY_PICTURE = 'apod/GET_PREVIOUS_OR_NEXT_DAY_PICTURE';
export const GET_PREVIOUS_OR_NEXT_DAY_PICTURE_SUCCESS =
  'apod/GET_PREVIOUS_OR_NEXT_DAY_PICTURE_SUCCESS';
export const GET_PREVIOUS_OR_NEXT_DAY_PICTURE_FAILURE =
  'apod/GET_PREVIOUS_OR_NEXT_DAY_PICTURE_FAILURE';
